import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { download, errMsg } from "@/lib/api";

export const SnapshotButton = ({ variant = "outline", testid = "snapshot-download" }) => {
  const [busy, setBusy] = useState(false);
  const [params, setParams] = useSearchParams();
  const run = async () => {
    setBusy(true);
    try {
      await download("/snapshot.xlsx", `EUDR action snapshot ${new Date().toISOString().slice(0, 10)}.xlsx`);
      toast.success("EUDR action snapshot downloaded");
    } catch (e) { toast.error(`Could not build the snapshot: ${errMsg(e)}`); } finally { setBusy(false); }
  };
  useEffect(() => {
    if (params.get("download") === "snapshot") { params.delete("download"); setParams(params, { replace: true }); run(); }
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Button variant={variant} data-testid={testid} disabled={busy} onClick={run}>
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileSpreadsheet className="mr-2 h-4 w-4" />}Download EUDR action snapshot (Excel)
    </Button>
  );
};
